// import ReactToPrint from "react-to-print";

import React, { Component } from 'react';
import Navigation from '../screens/Navigation.jsx';

import DatePicker from 'react-datepicker';
// import { registerLocale } from "react-datepicker";

import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
import axios from 'axios';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MdEdit, MdDelete, MdComment } from "react-icons/md";
import Markdownkatexnew from "./Markdown.js";
import WindowFocusHandler from "./isvisible.js";
import { Modal, Row } from "react-bootstrap";
import { isAuth, isAsignature } from "../helpers/auth.js";
import 'react-datepicker/dist/react-datepicker.css';

import { parseISO } from "date-fns";
import TimeAgo from 'timeago-react';
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
timeago.register('es', es);

// import es from 'date-fns/locale/es';
// registerLocale('es', es);

export default class Theme extends Component {
	open = () => this.setState({ showModal: true });
	close = () => this.setState({ showModal: false });

	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			updatable: false,
			name: props.name,
			status: props.status,
			nombre: "",
			contenido: "",
			tarea: "",
			www: "",
			wwwww: "",
			noww: new Date(),
			ber: "",
			themeall: "",
			fechaexa: new Date(),
			startDate: new Date(),
			timexa: "2",
			editing: false,
			integers: [],
			tassks: [],
			theme: [],
			title: "",
			description: "",
			articulo: { art1: 'el', art2: 'del', art3: 'al' },
			description: "",
			dateb: new Date(),
			datee: "",
			id: "",
			submit: "",
		};
	}

	getNotes = async () => {
		await axios.get(
			`${process.env.REACT_APP_API_URL}/seccions/${this.props.match.params.theme}/${this.props.match.params.curse}`
		).then(res => {
			if (res.data.length === 0) {
				this.createatachTheme()
			} else {
				console.log(res.data.length, res.data[0], "www");
				this.setState({
					id: res.data[0]._id,
					theme: res.data[0],
					tassks: res.data[0].tassks,
					dateb: parseISO(res.data[0].dateb),
					datee: parseISO(res.data[0].datee),
					title: res.data[0].title,
					description: res.data[0].description
				})
			}
		}).catch((err) => {
			console.log(err.response.statusText);
			toast.error(`Error To Your Information ${err.response.statusText}`);
			if (err.response.status === 401) { }
		});

	};

	async componentDidMount() {
		document.title = isAsignature().title
		// this.timeNow()
		let myLocale = "es"; // Persian (Farsi) locale with Latin numerals
		console.log(new Date().toLocaleString())
		// this.createatachTheme()
		this.getNotes();
	}


	createatachTheme = async () => {
		this.setState({
			isDisabled: "true"
		});
		console.log(this.props.match.params.curse, this.props.match.params.theme)
		await axios.post(`${process.env.REACT_APP_API_URL}/seccions`,
			{
				user: isAuth()._id,
				curse: this.props.match.params.theme,
				idtheme: this.props.match.params.curse,
				title: this.props.location.state.title,
				description: `# Wwwww
     
 Estoy pasando varias cantidades de datos en react markdown sich como tablas, listas y etiquetas h. Quería saber cómo diseñar cada elemento por separado. Busqué por todas partes pero no se menciona cómo diseñar los elementos más allá de simplemente negrita o énfasis, etc. 
    
## Wwwww

Pensé que podría pasar un nombre de clase en el componente ReactMarkdown para darle estilo, pero eso no solo proporcionaría estilo solo para el componente. ¿Cómo puedo darle estilo a los distintos elementos que contiene?

1. www
    1. First item
 2. Second item
 3. Third item
    1. Indented item
    2. Indented item
4. Fourth item $\\epsilon\\sum_1^3\\alpha$
 
# Wwwwwww

  $$
  \\sum_1^3=w_w^w
  $$
      
1. www
      
	* This is the first list item.
	
	* Heres the second list item.
   I need to add another paragraph below the second list item.
	
	* And heres the third list item.
			<iframe scrolling="no" title="Cartesian draw" src="https://www.geogebra.org/material/iframe/id/cy7eykhk/width/956/height/657/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/true/rc/false/ld/false/sdz/true/ctl/false" width="956px" height="657px" style="border:0px;"> </iframe>

  	wwwww $\\rho=\\frac{\\alpha}{3}=\\sqrt{w}$
      
2. Open the file containing the Linux mascot.
3. Marvel at its beauty.
					![Tux, the Linux mascot](https://assets.site-static.com/userFiles/1681/image/uploads/agent-1/buy-sell-land.jpg)
      
4. Close the file.
			At the command prompt, type <div class="mb-3">
			My favorite search engine is [Duck Duck Go](https://duckduckgo.com "The best search engine for privacy").
			www
			[![An old rock in the desert](https://assets.site-static.com/userFiles/1681/image/uploads/agent-1/buy-sell-land.jpg "Shiprock, New Mexico by Beau Rogers")](https://assets.site-static.com/userFiles/1681/image/uploads/agent-1/buy-sell-land.jpg)`,
				dateb: new Date(),
				datee: new Date(),
			}).then(res => {
				console.log(res)
			})
		this.getNotes()
	}


	submitTest = async e => {
		e.preventDefault();
		const Data = {
			title: this.props.location.state.title,
			description: this.state.description,
			dateb: this.state.dateb,
			datee: this.state.datee
		};
		await axios.put(`${process.env.REACT_APP_API_URL}/seccions/${this.state.id}`, Data).then(res => {
			this.close()
			this.getNotes()
			toast.info(res.data)
			console.log(res, "www")
		});
	};

	onTodoChange(www, wqw) {
		toast.info(www);
		console.log(www);
		toast.info(wqw);
		// this.setState({
		// 	[name]: value
		// });
	}

	calificationsimilar = async () => {
		var ntger = this.state.integers
		//console.log(this.photo.task)
		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			// let a1 = longer.toLowerCase().split(" ");
			// let b1 = shorter.toLowerCase().split(" ");
			//let result = a1.every((aa, i) => aa[0] === b1[i][0]);
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}
		var dattes = [];

		for (var j = 0; j < ntger.length; j++) {
			if (ntger[j].Usser[0].tassk.length >= 1) {
				dattes.push(Date.parse(ntger[j].Usser[0].tassk[0].createdAt))
			} else {
				console.log("www")
			}
		}


		for (var k = 0; k < ntger.length; k++) {
			this.charge = k + 1; //console.log(k,  this.charrge)
			if (ntger[k].Usser[0].tassk.length >= 1) {
				var www = [];
				var lenghtt = [];
				var ntgerwww = this.state.integers
				for (var j = 0; j < ntgerwww.length; j++) {
					if (ntgerwww[j].Usser[0].tassk.length >= 1 && ntgerwww[j].Usser[0].tassk[0]._id !== ntger[k].Usser[0].tassk[0]._id) {
						www.push(calculateSimilaritywww(ntgerwww[j].Usser[0].tassk[0].task, ntgerwww[k].Usser[0].tassk[0].task).score);
						lenghtt.push(ntgerwww[j].Usser[0].tassk[0].task.length);
					} else {
						www.push(0);
						lenghtt.push(0);
					}
				}
				var onepoint = (Math.max.apply(Math, dattes) - Math.min.apply(Math, dattes)) / 20
				var alcance = Date.parse(ntger[k].Usser[0].tassk[0].createdAt) - Math.min.apply(Math, dattes)
				const wsum = Object.values(www).reduce((a, b) => a + b, 0)
				var nota = 0.5 * (20 - wsum / (ntger.length - www.filter(w => w === 0).length) * (20 / 100)) + 0.3 * ntgerwww[k].Usser[0].tassk[0].task.length * 20 / Math.max(...lenghtt) + 0.2 * alcance / onepoint
				if (nota) {
					await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: '', note: Math.round(nota) + '' }).then(res => {
						//console.log(res)
					})
				} else {
					//console.log('sin nota')
				}
				this.setState({
					ber: k + 1
				});
			} else {
				//console.log("www")
			}
		}
		this.getNotes()
	}

	calificationsolution = async () => {
		//this.loading = "false"
		//console.log(this.state.tassks[1].task)
		// var www = [];
		var ntger = this.state.integers

		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			// let a1 = longer.toLowerCase().split(" ");
			// let b1 = shorter.toLowerCase().split(" ");
			//let result = a1.every((aa, i) => aa[0] === b1[i][0]);
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}

		for (var k = 0; k < ntger.length; k++) {
			if (ntger[k].Usser[0].tassk.length >= 1) {
				var numero = Number(ntger[k].Usser[0].tassk[0].solution) ? Number(ntger[k].Usser[0].tassk[0].solution) : 0
				var similaroriginal = calculateSimilaritywww(this.state.tassks[numero].task, this.state.tassks[numero].solution).score
				var similar = calculateSimilaritywww(ntger[k].Usser[0].tassk[0].task, this.state.tassks[numero].task).score
				var nota = (similar - similaroriginal) / ((100 - similaroriginal) / 20)

				this.setState({
					ber: k + 1
				});
				//console.log(this.photo.tassks[numero].task,"new")
				if (nota) {
					//this.loading = "false"
					await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: numero + '', note: Math.round(nota * 1000) / 1000 + '' }).then(res => {
						//console.log(res)
					})
				} else {
					console.log('wwwww')
				}
			} else {
				console.log('www');
			}
		}
		toast.dark('Calificado correctamente')
		this.getNotes()
	}



	calificationsolutionone = async (_id, taskk, solution) => {
		function calculateSimilaritywww(str1 = "", str2 = "") {
			let longer = str1.trim();
			let shorter = str2.trim();
			if (longer.length < shorter.length) [longer, shorter] = [shorter, longer];
			// var arr = [];
			let count = 0;
			for (var i = 0; i < longer.length; i++) {
				if (shorter && shorter.includes(longer[i])) {
					shorter = shorter.replace(longer[i], "")
					count++
				};
			}
			return {
				score: (count * 100) / longer.length
			}
		}
		var similaroriginal = calculateSimilaritywww(this.state.tassks[solution].task, this.state.tassks[solution].solution).score
		var similar = calculateSimilaritywww(taskk, this.state.tassks[solution].task).score
		console.log(this.state.tassks[solution].task, "new")
		var nota = (similar - similaroriginal) / ((100 - similaroriginal) / 20)
		console.log(nota)

		this.loading = "false"
		await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${_id}`, { task: taskk, solution: solution + '', note: Math.round(nota * 1000) / 1000 + '' }).then(res => {
			//console.log(res)
		})
		this.getNotes()
	}

	calificationclean = async () => {
		// var dattes = [];
		var ntger = this.state.integers

		for (var k = 0; k < ntger.length; k++) {
			if (ntger[k].Usser[0].tassk.length >= 1) {
				// var numero = Number(ntger[k].Usser[0].tassk[0].solution) ? Number(ntger[k].Usser[0].tassk[0].solution) : 0
				await axios.put(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`, { task: ntger[k].Usser[0].tassk[0].task, solution: ntger[k].Usser[0].tassk[0].solution, note: '' }).then(res => {
					console.log(res)
				})
			} else {
				console.log('www');
			}
		}
		toast.dark('Notas limpiadas correctamente')
		this.getNotes()
	}


	createTask = async (user) => {
		console.log(this.state.themeall.dateb, this.state.themeall.datee)
		await axios.post(`${process.env.REACT_APP_API_URL}/tasks`, { note: "", task: "task", solution: "3", theme: this.state.id, curse: this.props.match.params.theme, user: isAuth()._id, dateb: this.state.dateb, datee: this.state.datee })
			.then(res => {
				console.log(res)
			})
		this.getNotes()
	}

	//clean tasks
	cleantasks = async () => {
		if (window.confirm('Desea eliminar las tareas?')) {
			var ntger = this.state.integers
			for (var k = 0; k < ntger.length; k++) {
				if (ntger[k].Usser[0].tassk.length >= 1) {
					console.log(ntger[k].Usser[0].tassk[0]._id)
					await axios.delete(`${process.env.REACT_APP_API_URL}/tasks/${ntger[k].Usser[0].tassk[0]._id}`).then(res => {
						console.log(res)
					})
					//this.loading = "false"
					// this.themesService.deletetask(ntger[k].Usser[0].tassk[0]._id)
					// 	.subscribe(res => {
					// 		this.gettheme()
					// 	})
				} else {
					console.log('www');
				}
			}
			this.getNotes()
		}
	}

	onInputChange = (e) => {
		console.log(e.target.name, e.target.value);
		this.setState({ [e.target.name]: e.target.value })
	};


	cleantaskone = async (_id) => {
		if (window.confirm('Desea eliminar la tarea?')) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/tasks/${_id}`).then(res => {
				console.log(res)
			})
			this.getNotes()
		}
	}

	onSubmitRemove = async () => {
		const response = window.confirm('Deseas eliminar este capítulo?');
		if (response) {
			await axios.delete(`${process.env.REACT_APP_API_URL}/seccions/` + this.state.id);
			this.getNotes();
			toast.dark('Removido correctamente');
		}
	};

	getStdNativescalification = async (id) => {
		toast.info(id)
		const res = await axios.get(
			`${process.env.REACT_APP_API_URL}/users/stdaveragesnative/` + id
		);
		this.setState({
			integers: res.data,
		});
		console.log(res)

	};


	render() {
		return (
			<>
				<ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
				<Navigation />

				<div className='container'>

					{/* <button onClick={reactToPrintFn}>Imprimir sesión</button> */}
					{/* <button onClick={this.calificationclean()}>Imprimir sesión</button> */}
					{/* <div ref={(refer) => (this.componentRef = refer)}>Export my HTMl component to a PDF File</div>
						<ReactToPrint
							content={() => this.componentRef}
							trigger={() => (
								<button className="btn btn-primary">Print to PDF!</button>
							)}
						/>
						*/}
					<WindowFocusHandler />
					{isAuth()._id === this.state.theme.user ?
						<button className="btn btn-info text-center w-100" onClick={() => { this.open(); this.setState({ option: true, title: '', detail: '' }) }} > Editar </button>
						: ''}

					<h5 className="text-center">
						<span className='ffont h1 text-info'> {this.props.location.state.title}</span> <span className='ffont h1 text-center text-dark'>[{this.props.location.state.unittitle}] </span>
					</h5>

					<Modal show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
						<div className="modal-header font-weight-bold h5">Actualizar</div>
						<div className="modal-body">
							<div class="mb-3">
								<label for="wwwww" class="form-label">Detalle (Escriba texto en formato Markdown [<a href="https://www.markdownguide.org/basic-syntax/" target="_blank">Tutorial!</a>])</label>
								<textarea type="text" id="wwwww" className="form-control scroll" placeholder="Contenido" rows="9" name="description" onChange={this.onInputChange} value={this.state.description} required ></textarea>
								<Markdownkatexnew>
									{this.state.description}
								</Markdownkatexnew>
							</div>
						</div>
						<div className="modal-footer d-flex right-content-center">
							<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={this.submitTest}> Actualizar </button>
							<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.close() }}> Close </button>
						</div>
					</Modal >

					<Markdownkatexnew>
						{this.state.description}
					</Markdownkatexnew>

					<div className='rounded' style={{ backgroundColor: this.state.tassks.length>0 ? 'skyblue' : 'WhiteSmoke', padding: '1px'  }}>
						{isAuth()._id === this.state.theme.user ?
							<button className='btn btn-primary w-100' onClick={() => { this.createTask(this.state.themeall.user) }}>Crear tarea</button>
							: ''}
						<div className="row d-flex justify-content-center">
							{this.state.tassks.map((notew) => (
								<div className="text-center col-md-3 p-1" style={{margin:'.1em'}} key={notew._id} >
									<div className='rounded' style={{ backgroundColor: this.state.dateb < this.state.noww && this.state.noww < this.state.datee ? 'orange' : 'gray' }}>
										[{notew.task.length}-{notew.solution.length}]
										Inició <TimeAgo datetime={notew.dateb} locale='es' />. Culnima <TimeAgo datetime={notew.datee} locale='es' />
										<div className="p-1 btn-group w-100">
											<Link className="btn w-100 btn-info" to={'/test/' + notew._id} >
												Actualizar
											</Link>
											<Link className="btn w-100 btn-primary" to={'/test/' + notew._id} >
												Copiar
											</Link>
											<button className="btn btn-secondary w-100" onClick={() => { this.cleantaskone(notew._id) }}>
												Borrar
											</button>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>





					{isAuth()._id === this.state.theme.user ? <button className='btn btn-info w-100 mt-1' disabled={this.state.isDisabled === 'true'} onClick={() => {
						this.getStdNativescalification(this.props.match.params.theme)
					}}>Calificar nativos</button> : ''}

					{this.state.integers.length > 0 ?
						<div className="row d-flex justify-content-center bg-light p-1 border rounded">
							<div className="col-md-3 p-1">
								<button className="btn btn-warning w-100" onClick={this.cleantasks}>Limpiar tareas</button>
							</div>
							<div className="col-md-3 p-1">
								<button className="btn btn-info w-100" onClick={this.calificationclean}>Limpiar notas</button>
							</div>
							<div className="col-md-3 p-1">
								<button className="btn btn-outline-primary w-100" onClick={this.calificationsimilar}>Calificar similaridad</button>
							</div>
							{this.state.tassks !== '' ?
								<div className="col-md-3 p-1">
									<button className="btn btn-primary w-100" onClick={this.calificationsolution}>Calificar sesión</button>
								</div>
								: null}
						</div>
						: null}

					<div className="row justify-content-center align-items-center">
						{this.state.integers.map((note, i) => (
							<div className="col-md-4 p-1 m-0 text-center" key={i}>
								<div className="bg-info rounded text-center">
									<div>{i + 1}</div>
									<div>
										{note.usser[0].name}
									</div>
								</div>								{/* {note.Usser[0].tassk.length === 0 ?
										<td>
											<button className='btn btn-warning' onClick={() => { this.createTask(note.Usser[0]._id) }}>Crear tarea</button>
										</td> : null} */}
								{/* {note.Usser[0].tassk.map((notew, ii) => (
										<React.Fragment key={ii}>
											<td>
												{notew.note}
											</td>
											<td>
												<div className="btn-group">
													<Link className="btn btn-outline-secondary" to={'/test/' + notew._id} >
														<MdEdit />
													</Link>
													<button className="btn btn-outline-secondary" onClick={() => { this.cleantaskone(notew._id) }} >
														<MdDelete />
													</button>
													<button className="btn btn-outline-secondary" type="button" data-toggle="collapse" data-target={"#collapseOne" + note._id} aria-expanded="false" onClick={() => { this.calificationsolutionone(notew._id, notew.task, notew.solution) }}>
														<MdComment />
													</button>
												</div>
											</td>
											<td>
												{notew.task.length}
											</td>
											<td>
												{notew.createdAt}
											</td>
										</React.Fragment>
									))} */}
							</div>
						))
						}
					</div >


					{isAuth()._id === this.state.theme.user ?
						<>
							<div className="p-1 rounded my-3" style={{ backgroundColor: this.state.dateb < this.state.noww && this.state.noww < this.state.datee ? 'Gold' : 'WhiteSmoke' }}>
								{this.state.dateb < this.state.noww && this.state.noww < this.state.datee ?
									<div className="h3 w-100 text-center ffont" style={{ fontWeight: 'bold' }}>FECHA ACTIVADA</div> :
									<div className="h3 w-100 text-center ffont" style={{ fontWeight: 'bold' }}>FECHA NO ACTIVADA</div>
								}
								<div className="row p-1 d-flex">
									<div className="col-md-6 p-1 text-center">
										Inicia <TimeAgo datetime={this.state.dateb} locale='es' />
										<br /><DatePicker className='btn btn-info w-100' locale="es" showTimeSelect showIcon dateFormat="Pp"
											selected={this.state.dateb}
											onChange={(date) => {
												this.setState({ noww: new Date(), dateb: date })
												// console.log(date, this.state.theme.dateb)
											}}
										/>
									</div>
									<div className="col-md-6 p-1 text-center">
										Culmina <TimeAgo datetime={this.state.datee} locale='es' /><br /><DatePicker className='btn btn-info w-100' locale="es" showTimeSelect showIcon dateFormat="Pp"
											selected={this.state.datee}
											onChange={(date) => {
												this.setState({ noww: new Date(), datee: date })
												// console.log(date.toISOString())
											}}
										/>
									</div>
								</div>
								<button className='btn btn-info w-100 my-1' onClick={this.submitTest}>Actualizar campos</button>
								<button className='btn btn-danger w-100' onClick={this.onSubmitRemove}>Remover sesión</button>
							</div>
						</> : ''}

					<div className="text-warning w-100 text-center">{this.state.ber}</div>


				</div >
				<div className="py-3"></div>
			</>)
	}
}

